import React from 'react';
import { Factory, ShoppingBag } from 'lucide-react';
export function TechnologySection() {
  return <section id="technology" className="bg-gradient-to-b from-[#fafafa] to-[#f5f5f5] py-32 md:py-40 px-4" data-id="element-116">
      <div className="max-w-7xl mx-auto" data-id="element-117">
        <div className="mb-24" data-id="element-118">
          <p className="text-lg font-bold uppercase tracking-widest text-[#1e3a5f] mb-4" data-id="element-119">
            Our Solution
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-120">
          {/* Manufacturers Card */}
          <div className="bg-white p-10 md:p-16 rounded-3xl shadow-sm border border-gray-100 flex flex-col h-full hover:shadow-lg transition-shadow duration-300" data-id="element-121">
            <div className="w-12 h-12 bg-[#f0f5f9] rounded-full flex items-center justify-center mb-8 text-[#1e3a5f]" data-id="element-122">
              <Factory size={24} data-id="element-123" />
            </div>
            <h3 className="text-lg font-bold uppercase tracking-widest text-gray-400 mb-4" data-id="element-124">
              For Manufacturers
            </h3>
            <h4 className="text-3xl md:text-4xl font-semibold text-[#1a1a1a] mb-6" data-id="element-125">
              We are your data-driven distribution arm.
            </h4>
            <p className="text-lg text-gray-600 leading-relaxed mt-auto" data-id="element-126">
              We identify under-supplied, high demand sales channels for your
              goods; find buyers; and increase your sales and profits.
            </p>
          </div>

          {/* Retailers Card */}
          <div className="bg-[#1e3a5f] p-10 md:p-16 rounded-3xl shadow-xl flex flex-col h-full text-white hover:shadow-2xl transition-shadow duration-300" data-id="element-127">
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mb-8 text-white" data-id="element-128">
              <ShoppingBag size={24} data-id="element-129" />
            </div>
            <h3 className="text-lg font-bold uppercase tracking-widest text-white/60 mb-4" data-id="element-130">
              For Online Retailers
            </h3>
            <h4 className="text-3xl md:text-4xl font-semibold text-white mb-6" data-id="element-131">
              We are your outsourced procurement team.
            </h4>
            <p className="text-lg text-white/80 leading-relaxed mt-auto" data-id="element-132">
              We surface high-margin, fast-selling products tailored to your
              retail channel; and facilitate the transaction from purchase to
              delivery.
            </p>
          </div>
        </div>
      </div>
    </section>;
}